export default {
  fromDate: 'fromDate',
  toDate: 'toDate',
  onSelectDate: { $call: 'selectDate' },
};
